import ko from "knockout";
import _ from "lodash";

export default function multiSubscribe(
    targets,
    callback,
    ...koSubscribeRestArgs /* i.e callbackTarget, event */
) {
    if (!_.isArray(targets) || !_.every(targets, ko.isObservable)) {
        throw new Error(
            "multiSubscribe expects an array of observables (or computeds) as its first argument"
        );
    }

    const callbackFromTargets = function () {
        const currentValues = _.map(targets, function (target) {
            return target();
        });
        callback.apply(this, currentValues);
    };

    const subscriptions = _.map(targets, function (target) {
        return target.subscribe(callbackFromTargets, ...koSubscribeRestArgs);
    });

    return {
        dispose: function () {
            _.invokeMap(subscriptions, "dispose");
        },
    };
}
